/**
 * A module that handles webpacks public path.
 * @module abt-core/public-path
 */

import _ from 'lodash'
import { logError } from '../abt-utils/logger'

/** Sets webpack's public path global for chunck loading. */
export function setPublicPath () {
  var scripts = document.getElementsByTagName('script')

  var script = _.find(scripts, function (script) {
    return _.includes(script.src, '/abtest/')
  })

  if (!script) {
    logError('ABT: missing abtest script tag')
    return
  }

  __webpack_public_path__ = getPublicPath(script.src) // eslint-disable-line no-undef
}

/**
 * Gets the public path of a URL.
 * @param {string} url - The URL to evaluate.
 * @returns {string} Returns the public path of the provided URL.
 */
export function getPublicPath (url) {
  return url.split('/').slice(0, -1).join('/') + '/'
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-core/public-path.js
 ** module id = 12
 ** module chunks = 2 3
 **/